import {
  Component,
  OnDestroy,
  Inject,
  OnInit,
  ViewChild,
  ElementRef,
} from '@angular/core';
import {
  SuiModal,
  SuiModalService,
  ComponentModalConfig,
  ModalSize,
  DatepickerMode,
} from '@richardlt/ng2-semantic-ui';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { CompanyService, DocumentService } from '../../services';
import { AuthenticationService } from 'src/modules/core/services';
import { OrganizationService } from 'src/modules/features/contractor/services';

interface IuploadDocumentsModalContext {
  data?: any;
  title?: string;
  isEdit?: boolean;
}
@Component({
  selector: 'app-upload-document-modal',
  templateUrl: './upload-documents-modal.html',
  styleUrls: ['./upload-documents-modal.scss'],
})
export class uploadDocumentsModalComponent implements OnInit, OnDestroy {
  @ViewChild('input') input: ElementRef;
  @ViewChild('uploadDoc') uploadDoc: ElementRef;
  searchable: boolean = true;
  public mode: DatepickerMode = 'year';
  public maxDate = new Date();
  private unsubscribe$: Subject<void> = new Subject<void>();
  formSubmitAttempt: boolean;
  success: any;
  error: any;
  pending: boolean;

  companyDirector: any;

  companyType: Array<any> = [];
  ownershipType: Array<any> = [];
  countries: Array<any> = [];
  organizationId: string;
  currentForm: any;
  changeRequestId: string;
  heading: string;
  documentForm: FormGroup;
  selectedFile;
  fileNameArr: any = {};
  allFiles = [];
  uploadFormData: any;
  fileError;
  constructor(
    private companySvc: CompanyService,
    private modalService: SuiModalService,
    @Inject(DOCUMENT) private document,
    private fb: FormBuilder,

    private authSvc: AuthenticationService,
    private organizationSvc: OrganizationService,
    public modal: SuiModal<IuploadDocumentsModalContext, void, void>,
    private documentSvc: DocumentService
  ) {
    this.heading =
      modal.context.data.item == 'SHAREHOLDER_STRUCTURE'
        ? 'Shareholder'
        : 'Director';
    this.companyType = modal.context.data.companyType;
    this.countries = modal.context.data.countries;
    this.ownershipType = modal.context.data.ownershipType;
    this.organizationId = window.localStorage.getItem('organizationId');

    this.documentForm = this.fb.group({
      file: [''],
      documentName: ['Doc', Validators.required],
      documentDescription: ['supporting document'],
      documentTypeId: ['CHANGE_REQUEST_DOCUMENT'],
      documents: this.fb.array([]),
    });
  }
  get documents() {
    return this.documentForm.controls['documents'] as FormArray;
  }
  removeDocSegment(index: number) {
    this.documents.removeAt(index);
  }
  isFieldValid(field: string) {
    // return (
    //   (!this.companyDirectorForm.get(field).valid &&
    //     this.companyDirectorForm.get(field).touched) ||
    //   (this.companyDirectorForm.get(field).untouched && this.formSubmitAttempt)
    // );
    return (
      (!this.documentForm.get(field).valid &&
        this.documentForm.get(field).touched) ||
      (this.documentForm.get(field).untouched && this.formSubmitAttempt)
    );
  }

  displayFieldCss(field: string) {
    return {
      error: this.isFieldValid(field),
    };
  }

  displayFormCss(field: string) {
    return {
      loading: field,
    };
  }

  submit() {
    this.submitDoc();
    // this.modal.context.isEdit == true
    //   ? this.updateDirector('UPDATE')
    //   : this.save();
  }

  nullify() {
    this.success = null;
    this.error = null;
  }
  createDocument() {
    const docForm = this.fb.group({
      document: [null, Validators.required],
    });

    this.documents.push(docForm);
    this.uploadDoc.nativeElement.focus();
  }
  onFileChange(event, ind) {
    const files = event.target.files;
    if (!files) {
      return;
    }
    this.selectedFile = files[0];
    this.fileNameArr[ind] = this.selectedFile['name'];
    this.allFiles.push(this.selectedFile);
  }
  submitDoc() {
    this.formSubmitAttempt = false;
    if (this.fileError == null) {
      let data: any = this.documentForm.value;
      // this.allFiles.map(file => {})
      const formData: FormData = new FormData();
      formData.append('file', this.selectedFile, this.selectedFile.name);
      let payload: any = { formValue: data, formData: formData };
      // this.modal.approve(payload);

      this.uploadFormData = payload['formData'];
      const values = payload['formValue'];
      const jsonse = JSON.stringify(values);
      const blob = new Blob([jsonse], { type: 'application/json' });
      this.uploadFormData.append('data', blob);
      this.onUploadFile(this.uploadFormData);
    } else {
      this.formSubmitAttempt = true;
    }
  }

  onUploadFile(data) {
    this.nullify();
    this.pending = true;
    let result: any = {
      document: data,
    };
    this.success =
      'Document upload Successful. Ensure you save so that the request can undergo verification';
    setTimeout(() => {
      this.pending = false;
      this.modal.approve(result);
    }, 2000);
  }
  ngOnInit() {
    // this.document.body.classList.remove('panel');
  }
  // s
  ngOnDestroy(): void {
    // this.document.body.classList.add('panel');
  }
}

export class uploadDocumentsModal extends ComponentModalConfig<
  IuploadDocumentsModalContext,
  void,
  void
> {
  constructor(
    title: string,
    data: any,
    isEdit: boolean,
    size: ModalSize = ModalSize.Tiny
  ) {
    super(uploadDocumentsModalComponent, {
      title,
      data,
      isEdit,
    });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
